import { render, staticRenderFns } from "./showImage.vue?vue&type=template&id=000c07bc&scoped=true&"
import script from "./showImage.vue?vue&type=script&lang=js&"
export * from "./showImage.vue?vue&type=script&lang=js&"
import style0 from "./showImage.vue?vue&type=style&index=0&id=000c07bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000c07bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('000c07bc', component.options)
    } else {
      api.reload('000c07bc', component.options)
    }
    module.hot.accept("./showImage.vue?vue&type=template&id=000c07bc&scoped=true&", function () {
      api.rerender('000c07bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/showImage.vue"
export default component.exports